import { connect } from 'react-redux';
import TrackingList from '../../../../components/features/trackingList/TrackingList';
import { getChains } from 'core/slices/backend';
import { getSupplierStores } from 'core/slices/suppliers';
import { getClientStores } from 'core/slices/clients';
import { getUserSuppliers } from 'core/slices/users';
import {
  getTrackinglist,
  getTrackinglistItems,
  getTrackingListExcel,
} from 'core/slices/trackingList';
import {
  getChainsList,
  getSelectedClient,
  isLoadingChains,
  getTrackingListData,
  isLoadingTrackingListData,
  getTrackingListDataItems,
  isLoadingTrackingListDataItems,
  getClientStoresList,
  isLoadingClientStores,
  getSupplierStoresList,
  isLoadingSupplierStores,
  userSuppliers,
  isLoadingUserSuppliers,
} from 'core/selectors';

export default connect(state => ({
  trackingListData: getTrackingListData(state),
  loadingTrackingListData: isLoadingTrackingListData(state),
  trackingListDataItems: getTrackingListDataItems(state),
  loadingTrackingListDataItems: isLoadingTrackingListDataItems(state),
  clientStores: getClientStoresList(state),
  loadingClientStores: isLoadingClientStores(state),
  selectedClient: getSelectedClient(state),
  chains: getChainsList(state),
  isLoadingChains: isLoadingChains(state),
  supplierStores: getSupplierStoresList(state),
  isLoadingSupplierStores: isLoadingSupplierStores(state),
  suppliers: userSuppliers(state),
  isLoadingSuppliers: isLoadingUserSuppliers(state),
}), {
  getClientStores,
  getTrackinglist,
  getTrackinglistItems,
  getTrackingListExcel,
  getChains,
  getSupplierStores,
  getUserSuppliers,
})(TrackingList);
